import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { cn } from '../../lib/utils';

export function Loading({ className, size = 'default', text }) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    default: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <Icon name="spinner" className={cn('animate-spin text-accent', sizeClasses[size])} />
      {text && <p className="text-sm text-muted-foreground">{text}</p>}
    </div>
  );
}

export function PageLoading() {
  const { t } = useTranslation('common');
  return (
    <div className="min-h-[400px] flex items-center justify-center">
      <Loading size="lg" text={t('loading', 'Loading...')} />
    </div>
  );
}

export function FullPageLoading() {
  const { t } = useTranslation('common');
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      <Loading size="lg" text={t('loadingApp', 'Loading SnappiPit...')} />
    </div>
  );
}

export default Loading;
